import { createSlice } from "@reduxjs/toolkit";

export const counterSlice =createSlice({
    name:'counter',
    initialState:{
        value:0,
        value2:0,
    },
    reducers:{
        ReLottery:(state)=>{

            state.value2+=1
        },
        
        Lottery:(state,action)=>{
            state.value = String(action.payload.name) + String(action.payload.number);
        },
    },
})
export const{ ReLottery,Lottery} = counterSlice.actions
export default counterSlice.reducer